import React from "react";
import styled from "styled-components";
// import { useSelector } from "react-redux";
import { Col, Row, Card, CardBody, CardTitle } from "reactstrap";
import PropTypes from "prop-types";
// import GraphChart from "./Charts/GraphChart";
import PieChart from "./Charts/PieChart";

const QualityMediaSourceCharts = props => {
  // const state = useSelector(state => state.Reporting.charts);
  // const table_data = useSelector(
  //   state => state.Reporting.mediaSourceStats
  // ).results;

  return (
    <QualityMediaSourceChartsStyled>
      <Row>
        {/* <Col>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">Payment Chart</CardTitle>
              <GraphChart data={props.data} />
            </CardBody>
          </Card>
        </Col> */}
        {/* <Col>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">Profit Chart</CardTitle>
              <GraphChart data={state} />
            </CardBody>
          </Card>
        </Col> */}
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="xs-4 sm-4 mb-4 lg-4">Payment</CardTitle>
              <PieChart data={props.data} name="payment" />
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="xs-4 sm-4 mb-4 lg-4">Spend</CardTitle>
              <PieChart data={props.data} name="spend" />
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="xs-4 sm-4 mb-4 lg-4">Installs</CardTitle>
              <PieChart data={props.data} name="installs" />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </QualityMediaSourceChartsStyled>
  );
};

const QualityMediaSourceChartsStyled = styled.div`
  .apex-charts .apexcharts-data-labels text {
    fill: #fff !important;
  }
`;

QualityMediaSourceCharts.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
};

export default QualityMediaSourceCharts;
